import React from 'react';

import {EntitlementsPagination} from 'src/modules/entitlements';

import {mcpAccountEntitlementsStateActions, mcpAccountEntitlementsStateSelector} from '../slices/mcp-account-entitlements-state.slice';

type Props = {
    totalCount: number,
};

export const McpAccountEntitlementsPagination = ({totalCount}: Props) => (
    <EntitlementsPagination
        totalCount={totalCount}
        stateActions={mcpAccountEntitlementsStateActions}
        stateSelector={mcpAccountEntitlementsStateSelector}
    />
);
